import { render } from "./index.vue?vue&type=template&id=60c50786&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=60c50786&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-60c50786"

export default script